import maps from 'src/data/maps.json';

const { colors } = maps;

type DividerProps = {
    orientation?: 'horizontal' | 'vertical';
    thickness?: number;
    margin?: number;
    color?: string;
};

const Divider = ({
    orientation = 'horizontal',
    thickness = 1,
    margin = 16,
    color = colors['grey-200'],
}: DividerProps) => {
    return (
        <div
            aria-hidden
            style={{
                width: orientation === 'horizontal' ? '100%' : `${thickness}px`,
                height:
                    orientation === 'horizontal' ? `${thickness}px` : '100%',
                margin: `${margin}px 0`,
                backgroundColor: color,
            }}
        />
    );
};

export default Divider;
